const Icon = ({
  children,
  name = '',
  className = '',
  ...props
}: {
  children: React.ReactNode;
  name?: string;
} & React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...props} className={`icon ${name} ${className}`}>
    {children}
  </span>
);

export default Icon;
